import { useState } from 'react';
import { Container } from '@mui/material';
import { IUser, useDocumentTitle } from '../common';
import { DiTabs } from '.';

export const Di = ({ user }: { user: IUser }) => {
  useDocumentTitle({ title: 'Diversion Investigators' });

  const [currentTab, setCurrentTab] = useState(0);

  return (
    <Container maxWidth="xl" style={{ padding: 0 }}>
      <DiTabs
        user={user}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
      />
    </Container>
  );
};
